import type { AppKey } from '@/features/landing-page/data/app-detail'
import type { ProductId } from '@/features/solution-configurator/data/questions'
import { useSolutionConfiguratorFlow } from '@/features/solution-configurator/store/use-solution-configurator-flow'

/** Showcase app → configurator product id, so quote CTAs deep-link into the
    configurator's product step with the app(s) already ticked. */
export const APP_TO_PRODUCT: Record<AppKey, ProductId> = {
  alert: 'alertapp',
  evac: 'evacapp',
  livecount: 'livecount',
  safehuman: 'safehumanmanager',
  compliassist: 'compliassist',
}

/** Seed the shared configurator store so it opens on the product step with the
    given apps pre-ticked. When `note` is provided it prefills the gate form's
    "contexte particulier" field; when omitted the field is cleared so a note
    from a prior visit never lingers. */
export function seedConfiguratorApps(apps: readonly AppKey[], note?: string) {
  const flow = useSolutionConfiguratorFlow.getState()
  flow.setProducts(apps.map((k) => APP_TO_PRODUCT[k]))
  flow.setContact({ additionalContext: note ?? '' })
  flow.setStep('products')
}

/** Seed the configurator for the pricing Enterprise card: CompliAssist,
    6-20 sites, landing directly on the questions step. */
export function seedConfiguratorEnterprise() {
  const flow = useSolutionConfiguratorFlow.getState()
  flow.setProducts(['compliassist'])
  flow.setAnswer('siteCount', 'btw_6_20')
  flow.setStep('questions')
  useSolutionConfiguratorFlow.setState({ currentQuestion: 0 })
}

/** Send the visitor to the configurator's product step to pick their apps —
    used by the people-security "Entreprise" panel, with nothing pre-selected. */
export function seedConfiguratorProductStep() {
  const flow = useSolutionConfiguratorFlow.getState()
  flow.setProducts([])
  flow.setStep('products')
  useSolutionConfiguratorFlow.setState({ currentQuestion: 0 })
}
